import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CellEditorService {

    public editingCell: Element;
    public editingCellClick: boolean;
    public cellClosedEmitter: EventEmitter<void>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private documentEditListener: any;

    private triggerChangeDetection$: Subject<void> = new Subject();

    public updateEditingCell(cell: Element, cellClosedEmitter: EventEmitter<void>): void {
        this.editingCell = cell;
        this.cellClosedEmitter = cellClosedEmitter;
        this.bindDocumentEditListener();
        this.triggerChangeDetection$.next();
    }

    public bindDocumentEditListener(): void {
        if (!this.documentEditListener) {
            this.documentEditListener = (event: MouseEvent): void => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const onCdkOverlayElementClicked: boolean = event.composedPath().find((val: any) => val.id != null && val.id.indexOf('cdk-overlay') > -1) != null;
                if (onCdkOverlayElementClicked === false && this.editingCell && !this.editingCellClick && this.isEditingCellValid()) {
                    this.cellClosedEmitter.emit();
                    this.editingCell.classList.remove('editing-cell');
                    this.editingCell = null;
                    this.unbindDocumentEditListener();
                }

                this.editingCellClick = false;
            };

            document.addEventListener('click', this.documentEditListener);
        }
    }

    public unbindDocumentEditListener(): void {
        if (this.documentEditListener) {
            document.removeEventListener('click', this.documentEditListener);
            this.documentEditListener = null;
            this.triggerChangeDetection$.next();
        }
    }

    public isEditingCellValid(): boolean {
        return this.editingCell != null && Array.from(this.editingCell.querySelectorAll('.ng-invalid')).length === 0;
    }

    public isNotEditingOrIsEditingCellValid(): boolean {
        return this.editingCell == null || Array.from(this.editingCell.querySelectorAll('.ng-invalid')).length === 0;
    }

    public observeChangeDetection(): Observable<void> {
        return this.triggerChangeDetection$.asObservable();
    }

}
